import React from 'react';
import { Row, Col, Divider, Button, Form, Input, InputNumber } from 'antd';
import './style';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

export default React.forwardRef((props, ref) => {
  const { goodsName, goodsSpecName, onClose, onSaveCallback, price } = props;
  const [form] = Form.useForm();
  const onSave = async () => {
    const values = await form.validateFields();
    if (onSaveCallback) {
      onSaveCallback(values);
    }
  }
  const initValue = [
    { name: ['goods_name'], value: goodsName },
    { name: ['goods_spec_name'], value: goodsSpecName },
    { name: ['price'], value: price },
/*     { name: ['discount_min'], value: price && price.discount_min },
    { name: ['discount_max'], value: price && price.discount_max }, */
  ];
  return (
    <Form style={{ padding: '0.5rem 1rem' }} form={form} preserve={false} onFinish={onSave} fields={initValue}>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="产品名称" name="goods_name" rules={[{ required: true }]}>
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="　产品号" name="goods_spec_name" rules={[{ required: true }]}>
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="价　　格" name="price" rules={[{ required: true, message: '请输入价格!' }]}                            >
            <InputNumber style={{ width: '100%' }} ></InputNumber>
          </Form.Item>
        </Col>
      </Row>
      {/* <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="最小折扣" name="discount_min" rules={[{ required: true, message: '请选择支付方式!' }]}                            >
            <InputNumber min="0" max="100" style={{ width: '100%' }}></InputNumber>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="最大折扣" name="discount_max" rules={[{ required: true, message: '请选择支付方式!' }]}                            >
            <InputNumber min="0" max="100" style={{ width: '100%' }}></InputNumber>
          </Form.Item>
        </Col>
      </Row> */}
      <Divider />
      <Row gutter={[12, 12]} justify="end">
        <Col justify="end" span={24}>
          <div style={{ padding: '0 1rem', width: '100%', display: 'flex', justifyContent: 'right' }}>
            <div style={{ marginLeft: 'auto' }}></div>
            <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
            &nbsp;&nbsp;
            <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>确 定</Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
});
